import React from 'react'
import {Link} from 'react-router-dom'
import {SHOW_HELP_LINK} from "../../api"
import '../../stylesheets/Footer.css'

const Footer = () =>
    <footer className="navbar-fixed-bottom border-top bg-muted-sf-orange">
        <p className="text-muted">
            &copy; SurePoint Ag Systems {(new Date()).getFullYear()}
            {(SHOW_HELP_LINK ?
                <Link to="/help">Need Help?</Link>
                : null)}
        </p>
    </footer>

export default Footer



// WEBPACK FOOTER //
// ./src/components/ui/Footer.js